<template>
    <zen-one
        :showuserinfo="false"
        :title="'Dashboard Eksekutif'"
        :crumbs="crumbs"
    >
        <z-animate-number value="29"></z-animate-number>
        <GraphBarKutipan/>
    
        <!-- <JumlahKutipanWidget /> -->

        <w-divider class="my6"></w-divider>
        <w-tabs
            :items="tabs"
            right
            active-class="warning-light1"
            slider-color="deep-orange-light1"
            :no-slider="true"
            v-model="activeTab"
        >
            <template #item-content.1>
                <DashboardEISUtama :isActive="activeTab == 0"/>
            </template>

            <!-- PTJ -->
            <template #item-content.2>
                <DashboardEISPTJ :isActive="activeTab == 1"/>
            </template>

            <!-- Pejabat Tanah -->
            <template #item-content.3>
                <DashboardEISPejabatTanah :isActive="activeTab == 2"/>
            </template>

            <!-- Pejabat Daerah -->
            <template #item-content.4>
                <DashboardEISPejabatDaerah :isActive="activeTab == 3"/>
            </template>

            <!-- Jabatan Perhutanan -->
            <template #item-content.5>
                <DashboardEISPejabatPerhutanan :isActive="activeTab == 4"/>
            </template>
            
            <template #item-content.6 :isActive="activeTab == 5">
                <DashboardEISPelbagai/>
            </template>
        </w-tabs>
    </zen-one>
</template>

<script>
import Vue3ChartJs from "@j-t-mcc/vue3-chartjs";
import ChartJsPluginDataLabels from "chartjs-plugin-datalabels";

import GraphBarKutipan from "@/Pages/Dashboard/cart-EIS/GraphBarKutipan.vue";

import DashboardEISUtama from "./components/Dashboard-EIS-Utama.vue";
import DashboardEISPTJ from "./components/Dashboard-EIS-PTJ.vue";
import DashboardEISPejabatTanah from "./components/Dashboard-EIS-Pejabat-Tanah.vue";
import DashboardEISPejabatDaerah from "./components/Dashboard-EIS-Pejabat-Daerah.vue";
import DashboardEISPejabatPerhutanan from "./components/Dashboard-EIS-Pejabat-Perhutanan.vue";
import DashboardEISPelbagai from "./components/Dashboard-EIS-Pelbagai.vue";

Vue3ChartJs.registerGlobalPlugins([ChartJsPluginDataLabels]);

export default {
    components:{
        GraphBarKutipan,
        DashboardEISUtama,
        DashboardEISPTJ,
        DashboardEISPejabatTanah,
        DashboardEISPejabatDaerah,
        DashboardEISPejabatPerhutanan,
        DashboardEISPelbagai
    },
    setup() {
        return {};
    },
    data() {
        return {
            apiBaseUrl: process.env.MIX_API_BASE_URL,
            render: true,
            loading: false,
            tablePTJ: {
                columns: [],
                rows: [],
            },
            crumbs: [
                { label: this.$page.props.app_name, route: "/sitemap" },
                { label: "Dashboard Eksekutif", route: "/w-breadcrumbs" },
            ],
            showCard: false,
            tabs: [
                { title: "Utama", content: "" },
                { title: "PTJ", content: "" },
                { title: "Pejabat Tanah", content: "" },
                { title: "Pejabat Daerah", content: "" },
                { title: "Jabatan Perhutanan", content: "" },
                { title: "Pelbagai Jabatan", content: "" },
            ],
            activeTab: 0,
        };
    },
    methods: {
        handleSwitchTab(e) {
            this.activeTab = e;
        },
        async forceRerender() {
            this.render = false;
            await this.$nextTick();
            this.render = true;
        },
    },
    mounted(){},

};
</script>

<style>
.dashboard-box .w-image {
    background-size: contain;
}

.zdiimage {
    margin-right: 7px;
}

.dashboard-title {
    font-size: 17px;
    font-weight: bold;
    text-transform: uppercase;
}

.dashboard-percentage {
    position: absolute;
    right: 15px;
    font-weight: bold;
    font-size: 20px;
}

.dashboard-percentage-no {
    font-size: 20px;
}

.dashboard-more {
    position: absolute;
    right: 20px;
    top: 30px;
    color: #fff;
    background: #1f2248;
    padding: 3px 15px;
    border-radius: 5px;
    border: none;
}

.table-row-data {
    text-align: right;
}

path:hover,
circle:hover {
    stroke: #6666ff !important;
    stroke-width: 2px;
    stroke-linejoin: round;
    fill: #6666ff !important;
    cursor: pointer;
}

#info-box {
    display: none;
    position: absolute;
    top: 0px;
    left: 0px;
    z-index: 1;
    background-color: #ffffff;
    border: 2px solid #bf0a30;
    border-radius: 5px;
    padding: 5px;
    font-family: arial;
}

.row-color {
    background: #6666ff !important;
    color: white;
}

.ptj-table-data:nth-child(3n + 2) {
    background-color: rgba(247, 110, 17, 0.6);
}
.ptj-table-data:nth-child(3n + 3) {
    background-color: rgba(255, 159, 69, 0.6);
}
.ptj-table-data:nth-child(3n + 4) {
    background-color: rgba(166, 75, 42, 0.6);
}

.ptj-table-head-data{
    column-span: 3;
}
</style>
